import type { RouteRecordRaw } from 'vue-router';
import { STORE_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const onboardingRoutes: RouteRecordRaw = {
  path: '/onboarding',
  component: () => import('@/layouts/blank.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: STORE_ROUTE_NAME.ONBOARDING_STORE,
      path: '',
      component: () => import('./Onboarding.vue'),
    },
  ],
};
